import { Module } from 'vuex';
import { IRootState, IPortfolioState } from '@types';

const store: Module<IPortfolioState, IRootState> = {
    state: {},

    mutations: {},

    getters: {},

    actions: {},
};

export default store;
